<div
  class="modal-dialog modal-dialog-centered"
  role="dialog"
  aria-modal="true"
  data-testid="alert-dialog__root"
  [attr.aria-labelledby]="dialogRef.data?.title ? 'alert-dialog-title' : null"
  [attr.aria-describedby]="'alert-dialog-message'"
>
  <div class="modal-content">
    @if (dialogRef.data?.title) {
      <div class="modal-header">
        <h1
          id="alert-dialog-title"
          class="modal-title fs-5"
          [innerHTML]="dialogRef.data?.title! | translate | safeHtml"
        ></h1>
      </div>
    }
    <div
      id="alert-dialog-message"
      class="modal-body fs-5"
      [innerHTML]="dialogRef.data?.message ?? '' | translate | safeHtml"
    ></div>
    @if (hasButtonData()) {
      <div class="modal-footer">
        @if (dialogRef.data?.positiveButton) {
          <button
            class="btn btn-primary"
            type="button"
            data-testid="alert-dialog__positive"
            (click)="onClickPositive()"
          >
            {{
              dialogRef.data?.positiveButton?.text ?? 'BUTTON.Ok' | translate
            }}
          </button>
        }
        @if (dialogRef.data?.negativeButton) {
          <button
            class="btn btn-outline-secondary"
            type="button"
            data-testid="alert-dialog__negative"
            (click)="onClickNegative()"
          >
            {{
              dialogRef.data?.negativeButton?.text ?? 'BUTTON.Cancel'
                | translate
            }}
          </button>
        }
        @if (dialogRef.data?.neutralButton) {
          <div class="space"></div>
          <button
            class="btn btn-primary-outline"
            type="button"
            (click)="onClickNeutral()"
          >
            {{
              dialogRef.data?.neutralButton?.text ?? 'BUTTON.Close' | translate
            }}
          </button>
        }
      </div>
    }
  </div>
</div>
